function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { campaignAlertsSlice } from '../campaignAlerts';
export var campaignsAdapter = createEntityAdapter({});
export var campaignsSlice = createSlice({
    name: 'campaigns',
    initialState: campaignsAdapter.getInitialState(),
    reducers: {
        campaignsFetched: campaignsAdapter.upsertMany,
        campaignFetched: function(state, action) {
            var _rawCampaign_included;
            var rawCampaign = action.payload;
            var campaign = _object_spread({}, rawCampaign.data.attributes);
            (_rawCampaign_included = rawCampaign.included) === null || _rawCampaign_included === void 0 ? void 0 : _rawCampaign_included.forEach(function(included) {
                if (included) {
                    // TODO: we can improve the inference of these types
                    switch(included.type){
                        case 'campaign_score':
                            campaign.campaignScore = included.attributes;
                            break;
                        case 'campaign_fielding_stat':
                            campaign.fieldingStats = included.attributes;
                            break;
                        default:
                            break;
                    }
                }
            });
            return campaignsAdapter.upsertOne(state, campaign);
        },
        campaignHealthStatusFetched: function(state, action) {
            var _action_payload = action.payload, status = _action_payload.status, campaign_id = _action_payload.campaign_id;
            var campaign = {
                id: campaign_id,
                healthStatus: status
            };
            return campaignsAdapter.upsertOne(state, campaign);
        },
        campaignUpdated: campaignsAdapter.updateOne
    },
    extraReducers: function(builder) {
        builder.addCase(campaignAlertsSlice.actions.campaignAlertsFetched, function(state, param) {
            var _param_payload = param.payload, campaignId = _param_payload.campaignId, alerts = _param_payload.alerts;
            var alertIds = alerts.map(function(alert) {
                return alert.id;
            });
            campaignsAdapter.updateOne(state, {
                id: campaignId,
                changes: {
                    alertIds: alertIds
                }
            });
        });
    }
});
